export const AppPage = {
  flow: 'x',
  width: '100%',
  maxWidth: 'none',
  margin: '0',
  padding: '0',
  overflow: 'hidden',
  theme: 'document'
}
